<template>
      <Nav></Nav>
</template>
<script>
import Nav from '@/components/Nav'
export default {
  name: 'Header',
  components: {Nav},
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .header {
    background: #3f51b5;
  }
</style>
